
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icons",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","width":"1.2em","height":"1.2em"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M438 387L307 256l131-131c14-14 14-36 0-50-15-15-37-15-51 0L256 205 125 75c-14-15-36-15-50 0-15 14-15 36 0 50l130 131L75 387c-15 14-15 36 0 51 14 14 36 14 50 0l131-131 131 131c14 14 36 14 51 0 14-15 14-37 0-51z"}})])
          )
        }
      }
    